/**
 * Componente StatCard - ConfereAI
 *
 * Card de estatísticas padronizado.
 * Baseado no layout da página de Veículos.
 */

import React from 'react';
import './StatCard.css';

interface StatCardProps {
  icon: string;
  value: string | number;
  label: string;
  color?: 'primary' | 'info' | 'warning' | 'danger';
  className?: string;
}

const StatCard: React.FC<StatCardProps> = ({
  icon,
  value,
  label,
  color = 'primary',
  className = '',
}) => {
  return (
    <div className={`stat-card stat-card-${color} ${className}`}>
      <div className="stat-icon">
        <i className={icon}></i>
      </div>
      <div className="stat-value">{value}</div>
      <div className="stat-label">{label}</div>
    </div>
  );
};

export default StatCard;
